export default __webpack_public_path__ + "static/media/ringlady.c30c5253.png";